export const overviewScrollPosition = state => {
  if (state.overviewScrollPositionTop !== null && state.overviewScrollPositionLeft !== null) {
    return {
      top: state.overviewScrollPositionTop,
      left: state.overviewScrollPositionLeft,
    };
  }
};

export const calendarDate = state => {
  return state.calendarDate;
};

export const isOrgActive = state => {
  return state.isOrgActive;
};
